
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncLevelGrid extends Serenity.EntityGrid<PsFuncLevelRow, any> {
        protected getColumnsKey() { return PsFuncLevelColumns.columnsKey; }
        protected getDialogType() { return PsFuncLevelDialog; }
        protected getIdProperty() { return PsFuncLevelRow.idProperty; }
        protected getInsertPermission() { return PsFuncLevelRow.insertPermission; }
        protected getLocalTextPrefix() { return PsFuncLevelRow.localTextPrefix; }
        protected getService() { return PsFuncLevelService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}